import React from "react";
import Header from "../common/Header/header.jsx";
import Footer from "../common/Footer/footer.jsx";
import { getPublications } from "./dataPublications.jsx";
import _ from "lodash";
import "./publications.css";

const PublicationsPage = () => {
  const years = getPublications.map((publication) => publication.year);
  const publicationYears = [...new Set(years)];
  const publicationsByYear = _.groupBy(getPublications, "year");

  return (
    <>
      <Header />
      <div className="publications-section my-2">
        <div className="yearsOfPublication">
          {publicationYears.map((year, index) => (
            <div key={index} className="d-flex">
              <a href={`#${year}`}>{year}</a>
              {index < publicationYears.length - 1 && (
                <span className="mx-1">|</span>
              )}
            </div>
          ))}
        </div>
        <div>
          {publicationYears.map((year) => (
            <div key={year}>
              <div className="yearsOfPublication">
                <a id={year} href={`#${year}`}>
                  {year}
                </a>
                <a className="mx-3" href={`#top`}>
                  Top
                </a>
              </div>
              <ul>
                {publicationsByYear[year].map((publication, index) => (
                  <li key={index} className="m-0">
                    <span className="fw-bold">{publication.authors}</span>
                    <span>({publication.year}).</span>
                    <span>{publication.title}</span>
                    <span className="fw-bold">{publication.journal} DOI:</span>
                    <a
                      className="text-break text-decoration-none"
                      href={publication.url}
                      target="_main"
                    >
                      {publication.doi}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PublicationsPage;
